import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {CompteApi} from "@domain/admin/parametre/api/compte-api";
import {ApiRestService} from "@services/admin/parametre/api/api-rest.service";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {TranslateService} from "@ngx-translate/core";
import {filter} from "rxjs/operators";
import {TypeCodeErreur} from "@domain/common/http/result";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";

/**
 * Item de la liste des comptes API REST
 */
@Component({
	host: {'data-test-id': 'api-rest-list-item'},
	selector: 'api-rest-list-item',
	templateUrl: './api-rest-list-item.component.html'
})
export class ApiRestListItemComponent extends ListViewItem<CompteApi> {
	/**
	 * Constructeur
	 */
	constructor(
        private confirmService: ConfirmService,
        private apiRestService: ApiRestService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private router: Router) {
		super();
	}

	/**
	 * Fonction appelée au clic sur un compte API
	 */
	navigateTo(): void {
        //Navigation vers la page de détails du compte
        this.router.navigate([`Admin/Parametre/API/Rest/${this.data.idCompte}`]);
	}

    /**
     * Suppression du compte API
     */
    deleteCompte(): void {
        //Popup de confirmation
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed)).subscribe({
            next: () => {
                //Suppression du compte API
                this.apiRestService.deleteCompteApi(this.data.idCompte).subscribe(result => {
                    if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                        //Refresh la liste des comptes
                        this.liste.refresh();

                        //Toast de succès
                        this.toastrService.success(this.translateService.instant('global.success.suppression'));
                    } else {
                        //Toast d'erreur
                        this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                    }
                })
            }
        });
    }
}